import React from 'react';
import 'emoji-mart/css/emoji-mart.css';
import { Picker } from 'emoji-mart';
import 'custom-event-polyfill';

const EmojiPicker = () => {
  return (
    <div className='react-emoji-picker'>
      <Picker
        set='emojione'
        title=""
        emoji=""
        onSelect={(e) => window.dispatchEvent(new CustomEvent('emoji-picked', { detail: e }))}
        custom={$('.autocomplete-data').data('emoji-list')}
      />;
    </div>
  )
};

export default EmojiPicker;
